import { render } from "./PictureList.vue?vue&type=template&id=e265ba48&scoped=true"
import script from "./PictureList.vue?vue&type=script&lang=js"
export * from "./PictureList.vue?vue&type=script&lang=js"

import "./PictureList.vue?vue&type=style&index=0&id=e265ba48&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e265ba48"]])

export default __exports__